import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreatePythonFunctionRequest, QueryKey } from 'api/model';
import { toast } from 'react-toastify';
import { create as createRequest, getGlobalList, getProjectList } from './requests';
import { errorHandler } from 'api/axios_instance';

const queryKey = QueryKey.PythonFunctions;

const usePythonFunctions = (
  projectId: string | null = null,
  includeGlobal = false,
  unusedOnly = false,
  enabled = true,
) => {
  const queryClient = useQueryClient();

  const queryFn = () =>
    projectId === null ? getGlobalList(unusedOnly) : getProjectList(projectId, includeGlobal, unusedOnly);
  const {
    data: functions,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: [queryKey, { projectId, includeGlobal, unusedOnly }],
    queryFn,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled,
  });

  const create = useMutation({
    mutationFn: (model: CreatePythonFunctionRequest) => createRequest(model),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [queryKey] });
      void queryClient.invalidateQueries({ queryKey: [QueryKey.PythonFunctionFolders] });
      toast.success('Python function successfully created');
    },
    onError: errorHandler('Creating python function failed'),
  });

  return { functions, isLoading, create, isFetching };
};

export { queryKey };
export default usePythonFunctions;
